module.exports = __webpack_public_path__ + "static/img/s-mi-4.11511f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-mi-4.png
// module id = wQr/
// module chunks = 1